// UI strings for the couple session's additions of 2026-10-07 (docs/PEDAGOGY.md §3.4;
// together/couple/, together/halloween/): "Meidän suunnitelma" and the Halloween line (the line
// gestures, "Ele", were removed on 2026-10-12). Finnish (default) and English side by side, the same shape.
import { defineArea } from '../area';

export const coupleFi = {
  plan: {
    title: 'Meidän suunnitelma',
    /** The hub's row. */
    rowNone: 'Minuutti lopuksi: milloin ja missä harjoittelette ensi viikolla',
    rowThis: (days: string, note: string) => `Tällä viikolla: ${[days, note].filter(Boolean).join(' · ')}`,
    rowNext: (days: string, note: string) => `Ensi viikolla: ${[days, note].filter(Boolean).join(' · ')}`,
    forWeek: (n: number, from: string, to: string) => `Ensi viikko · viikko ${n} · ${from}–${to}`,
    days: 'Päivät',
    dayShort: ['ma', 'ti', 'ke', 'to', 'pe', 'la', 'su'],
    dayLong: ['maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai', 'sunnuntai'],
    note: 'Milloin ja missä?',
    notePlaceholder: 'esim. ti ja to klo 19 keittiössä',
    save: 'Tallenna suunnitelma',
    skip: 'Ohita',
    saved: 'Tallennettu teille molemmille.',
    setBy: (name: string) => `Viimeksi muokannut ${name}.`,
    next: 'Lopuksi: meidän suunnitelma',
  },
  halloween: {
    title: 'Halloween-lause',
    rowIdea: (slot: string) => `${slot}: idea – valyriasta puuttuu vielä sana`,
    over: 'Halloweenin sitsit on pidetty.',
    themes: {
      greeting: 'Tervehdys',
      toast: 'Malja',
      table: 'Pöytäkeskustelu',
      speech: 'Puhe',
      character: 'Hahmossa',
      farewell: 'Hyvästit',
    },
    suggestion: 'Ehdotus',
    notApproved: 'ei vielä hyväksytty',
    idea: 'Idea',
    missing: (words: string) => `Sanakirjasta puuttuu: ${words}`,
    source: {
      example: 'Petersonin esimerkkilause',
      show: 'Sarjan repliikki',
      word: 'Sanakirjan sana',
      lesson: 'Oppitunnin lause',
      stack: 'Lausepinon lause',
    },
    ours: 'Meidän versio',
    hvField: 'Valyriaksi',
    meaningField: 'Merkitys',
    useSuggestion: 'Käytä ehdotusta',
    save: 'Tallenna teille molemmille',
    edit: 'Muokkaa',
    remove: 'Poista',
    cancel: 'Peru',
    savedBy: (name: string, date: string) => `${name} tallensi ${date}.`,
    savedByYou: (date: string) => `Tallensit ${date}.`,
    record: 'Äänittäkää lause',
    all: 'Lauseet tähän asti',
    upcoming: (n: number) => (n === 1 ? 'Sitseihin on vielä yksi lause.' : `Sitseihin on vielä ${n} lausetta.`),
    open: 'Avaa',
    check: 'Tarkistus',
    checkOk: 'Sovellus ei löytänyt lauseesta virhettä.',
  },
};

export const coupleEn: typeof coupleFi = {
  plan: {
    title: 'Our plan',
    rowNone: 'One minute to finish: when and where you study next week',
    rowThis: (days, note) => `This week: ${[days, note].filter(Boolean).join(' · ')}`,
    rowNext: (days, note) => `Next week: ${[days, note].filter(Boolean).join(' · ')}`,
    forWeek: (n, from, to) => `Next week · week ${n} · ${from}–${to}`,
    days: 'Days',
    dayShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    dayLong: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    note: 'When and where?',
    notePlaceholder: 'e.g. Tue and Thu at 7 pm in the kitchen',
    save: 'Save the plan',
    skip: 'Skip',
    saved: 'Saved for you both.',
    setBy: (name) => `Last changed by ${name}.`,
    next: 'To finish: our plan',
  },
  halloween: {
    title: 'Halloween line',
    rowIdea: (slot) => `${slot}: an idea, no High Valyrian word yet`,
    over: 'The Halloween feast has been held.',
    themes: {
      greeting: 'Greeting',
      toast: 'Toast',
      table: 'Table talk',
      speech: 'Speech',
      character: 'In character',
      farewell: 'Farewell',
    },
    suggestion: 'Suggestion',
    notApproved: 'not approved yet',
    idea: 'Idea',
    missing: (words) => `Missing from the dictionary: ${words}`,
    source: {
      example: 'Peterson’s example sentence',
      show: 'A line from the show',
      word: 'A dictionary word',
      lesson: 'A lesson sentence',
      stack: 'A sentence-stack sentence',
    },
    ours: 'Our version',
    hvField: 'In High Valyrian',
    meaningField: 'Meaning',
    useSuggestion: 'Use the suggestion',
    save: 'Save for you both',
    edit: 'Edit',
    remove: 'Remove',
    cancel: 'Cancel',
    savedBy: (name, date) => `Saved by ${name} on ${date}.`,
    savedByYou: (date) => `You saved it on ${date}.`,
    record: 'Record the line',
    all: 'Lines so far',
    upcoming: (n) => (n === 1 ? 'One more line before the feast.' : `${n} more lines before the feast.`),
    open: 'Open',
    check: 'Check',
    checkOk: 'The app found no error in the line.',
  },
};

// Messages.couple (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('couple', coupleFi, coupleEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof coupleFi> {}
}
